import styled from 'styled-components';

export const NotificationButton = styled.div`
  display: inline-block;
  margin-left: ${({ theme }) => theme.spacing[4]};
`;
